import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { fontWeight, space } from '@synoptic/ui-kit/tokens.ts';
import { globalStyle, style } from '@vanilla-extract/css';

export const importantText = style([
  {
    fontWeight: fontWeight.bold,
  },
]);

export const mfaSecret = style([
  {
    wordWrap: 'break-word',
  },
]);

export const stepsList = style([
  {
    padding: `0 ${space.s14}px`,
    marginTop: 0,
  },
]);

export const qrCodeContainer = style([
  {
    display: 'flex',
    margin: `${space.s14}px 0`,
  },
]);

export const detailedListItem = style([
  {
    marginBottom: space.s14,
  },
]);

export const buttonsBox = style([
  {
    display: 'flex',
    gap: space.s16,
  },
  responsiveStyle({
    mobile: {
      marginTop: space.s24,
      flexDirection: 'column-reverse',
    },
    tablet: {
      marginTop: space.s35,
      flexDirection: 'row',
    },
  }),
]);

globalStyle(`${buttonsBox} > button`, {
  flexBasis: '50%',
});
